var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default",null,null,{ zloading: _vm.loading, onClick: _vm.callFunction, show: !_vm.showCountdown }),_vm._v(" "),_vm._t("countdown",null,null,{ show: _vm.showCountdown, delaytime: _vm.getTime, onCountdownEnd: _vm.onCountdownEnd })],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32eca970","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Cooldown.vue
// module id = null
// module chunks = 